const SECOND_MS = 1000;
const MINUTE_MS = 60 * SECOND_MS;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;
const WEEK_MS = 7 * DAY_MS;

const UNIT_TO_MS: Record<string, number> = {
  s: SECOND_MS,
  m: MINUTE_MS,
  h: HOUR_MS,
  d: DAY_MS,
  w: WEEK_MS,
};

const TOKEN_RE = /(\d+)([smhdw])/g;

export const parseIntervalToMs = (interval: string): number => {
  let total = 0;
  let match: RegExpExecArray | null;
  TOKEN_RE.lastIndex = 0;
  while ((match = TOKEN_RE.exec(interval)) !== null) {
    const value = Number(match[1]);
    const unit = match[2];
    total += value * (UNIT_TO_MS[unit] ?? 0);
  }
  return total;
};
